export enum TipoBienesRaices
{
    Casa = "Casa",
    Departamento= "Departamento",
    Oficina = "Oficina",
    Terreno = "Terreno",
}